import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Type = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  width: 100%;
  align-items: flex-end;
  gap: 10px;
`;
